import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetInfoRiesgoEmbarazoLactancia = {
  status: number | null;
  statusText: string | null;
};

const useGetInfoRiesgoEmbarazoLactancia = () => {
  const [loadingGetInfoRiesgoEmbarazoLactancia, setLoadingGetInfoRiesgoEmbarazoLactancia] = useState(false);
  const [successGetInfoRiesgoEmbarazoLactancia, setSuccessGetInfoRiesgoEmbarazoLactancia] = useState(false);
  const [errorGetInfoRiesgoEmbarazoLactancia, setErrorGetInfoRiesgoEmbarazoLactancia] = useState<any>(null);
  const [dataGetInfoRiesgoEmbarazoLactancia, setDataGetInfoRiesgoEmbarazoLactancia] = useState<any>(null);

  const [statusGetInfoRiesgoEmbarazoLactancia, setStatusGetInfoRiesgoEmbarazoLactancia] =
    useState<StatusGetInfoRiesgoEmbarazoLactancia>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getInfoRiesgoEmbarazoLactancia = async (
    userId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetInfoRiesgoEmbarazoLactancia(true);
    setSuccessGetInfoRiesgoEmbarazoLactancia(false);
    setErrorGetInfoRiesgoEmbarazoLactancia(null);

    try {
      const res = await apiRecord.getInfoSolicitudReconocimientoREL(userId);

      setStatusGetInfoRiesgoEmbarazoLactancia({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessGetInfoRiesgoEmbarazoLactancia(true);
      setDataGetInfoRiesgoEmbarazoLactancia(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetInfoRiesgoEmbarazoLactancia({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetInfoRiesgoEmbarazoLactancia(err);
      console.error("Error en getInfoRiesgoEmbarazoLactancia:", err);

      throw err;

    } finally {
      setLoadingGetInfoRiesgoEmbarazoLactancia(false);
    }
  };

  return {
    getInfoRiesgoEmbarazoLactancia,
    loadingGetInfoRiesgoEmbarazoLactancia,
    successGetInfoRiesgoEmbarazoLactancia,
    errorGetInfoRiesgoEmbarazoLactancia,
    dataGetInfoRiesgoEmbarazoLactancia,
    statusGetInfoRiesgoEmbarazoLactancia
  };
};

export default useGetInfoRiesgoEmbarazoLactancia;
